import { ProductLandingPageSettingsEntity } from "@features/products/domain";
import { ProductLandingPageSettingsModel } from "../models/landing-page-settings.model";

export function mapLandingPageSettings(
  model: ProductLandingPageSettingsModel,
): ProductLandingPageSettingsEntity {
  return {
    active: model.active,
    description: model.description,
    media: model.productPicturesURLs,
    price: model.productPrice,
    isAddressFormLong: model.isAddressFormLong,
    url: model.url,
    productName: model.productName,
    pixelId: model.pixelId,
    id: model.id,
  };
}
